<template>
  <div class="user-selector">
    <v-text-field
      outlined
      dense
      clearable
      hide-details
      prepend-inner-icon="mdi-magnify"
      :placeholder="label"
      v-model="searchTerms"
      @input="onSearchChanged"
    >
    </v-text-field>
    <v-skeleton-loader
      v-if="loading"
      class="pt-1 px-2"
      type="list-item-avatar-two-line,
      list-item-avatar-two-line,
      list-item-avatar-two-line,
      list-item-avatar-two-line"
    ></v-skeleton-loader>
    <UsersList
      v-else
      :users="userList"
      :emptyStateImg="emptyStateImage"
      :emptyStateText="emptyStateText"
      :showSelection="showSelection"
      :coachingText="coachingText"
      :ofText="ofText"
      @userClicked="userClicked"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import UsersList from './UsersList.vue'
import emptyStateSearch from './assets/emptyStateSearch.svg'

export default {
  name: 'UserSelector',
  components: {
    UsersList,
  },
  props: {
    users: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: function() {
        return 'multiple'
      },
    },
    label: {
      type: String,
      required: true,
    },
    emptyStateText: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      required: false,
    },
    initialSelection: {
      type: Array,
      required: false,
      default: function() {
        return []
      },
    },
    showSelection: {
      type: Boolean,
      required: false,
      default: true,
    },
    coachingText: {
      type: String,
      required: false,
    },
    ofText: {
      type: String,
      required: false,
    },
    completedBy: {
      type: Object,
      required: false,
      default: () => {},
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      selectedUsers: this.initialSelection,
      searchTerms: '',
    }
  },

  computed: {
    userList() {
      const nonSelectedUsers = this.users.filter(user => {
        return (
          !this.isUserSelected(this.selectedUsers, user) && !user?.isDeleted
        )
      })
      const selectedUsers = this.selectedUsers.map(user => {
        return Object.assign({}, user, { selected: true })
      })
      return [...selectedUsers, ...nonSelectedUsers]
    },
    emptyStateImage() {
      return emptyStateSearch
    },
  },
  methods: {
    userClicked(user) {
      if (!this.isUserSelected(this.selectedUsers, user)) {
        this.selectedUsers = this.addUser(this.selectedUsers, user)
        this.emitSelectionChanged()
      } else if (!this.isCompletedBy(user)) {
        this.selectedUsers = this.removeUser(this.selectedUsers, user)
        this.emitSelectionChanged()
      } else {
        window.alert(
          this.$t(
            'quick_action.after.you_cannot_remove_this_team_member_because_they_have_been_selected_as_the_problem_solver'
          )
        )
      }
    },

    emitSelectionChanged() {
      this.$emit(
        'selectionChanged',
        this.selectedUsers.map(user => _.omit(user, 'selected'))
      )
    },

    getIds(users) {
      return users.map(user => user?.id ?? user?._id)
    },

    isCompletedBy(user) {
      return user.id === _.get(this.completedBy, 'id', '')
    },

    isUserSelected(selectedUsers, user) {
      return _.includes(this.getIds(selectedUsers), user.id)
    },

    removeUser(selectedUsers, user) {
      return selectedUsers.filter(selectedUser => selectedUser.id !== user.id)
    },

    addUser(selectedUsers, user) {
      if (this.type === 'single') {
        return [user]
      }
      if (this.reachedLimit(selectedUsers)) {
        return selectedUsers
      }

      return [...selectedUsers, user]
    },

    reachedLimit(selectedUsers) {
      if (!this.limit) return false

      return this.limit === selectedUsers.length
    },

    onSearchChanged() {
      return this.$emit('onSearchChanged', this.searchTerms)
    },
  },
}
</script>

<style lang="scss" scoped>
.share-rev__usersList {
  padding: 12px;
}
</style>
